import { AppConfig } from 'src/app/app.config';
import { HttpClient } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../app.config";
var DriversService = /** @class */ (function () {
    function DriversService(http, config) {
        this.http = http;
        this.config = config;
    }
    DriversService.prototype.datatable = function (data) {
        return this.http.post(this.config.getConfig("apiEndpoint") + "/drivers/dt", data);
    };
    DriversService.prototype.get = function (id) {
        return this.http.get(this.config.getConfig("apiEndpoint") + "/drivers/" + id);
    };
    DriversService.prototype.getAll = function () {
        return this.http.get(this.config.getConfig("apiEndpoint") + "/drivers/all");
    };
    DriversService.prototype.update = function (a) {
        return this.http.put(this.config.getConfig("apiEndpoint") + "/drivers", a);
    };
    DriversService.prototype.insert = function (a) {
        return this.http.post(this.config.getConfig("apiEndpoint") + "/drivers", a);
    };
    DriversService.prototype.delete = function (id) {
        return this.http.delete(this.config.getConfig("apiEndpoint") + "/drivers/" + id);
    };
    DriversService.prototype.getDriverMyself = function () {
        return this.http.get(this.config.getConfig("apiEndpoint") + "/drivers/myself");
    };
    DriversService.prototype.wizardInsert = function (a) {
        return this.http.put(this.config.getConfig("apiEndpoint") + "/drivers/wizard", a);
    };
    DriversService.ngInjectableDef = i0.defineInjectable({ factory: function DriversService_Factory() { return new DriversService(i0.inject(i1.HttpClient), i0.inject(i2.AppConfig)); }, token: DriversService, providedIn: "root" });
    return DriversService;
}());
export { DriversService };
var Autista = /** @class */ (function () {
    function Autista() {
    }
    return Autista;
}());
export { Autista };
